import { render, staticRenderFns } from "./assignRoleDialog.vue?vue&type=template&id=2aeccfa7&scoped=true&"
import script from "./assignRoleDialog.vue?vue&type=script&lang=js&"
export * from "./assignRoleDialog.vue?vue&type=script&lang=js&"
import style0 from "./assignRoleDialog.vue?vue&type=style&index=0&id=2aeccfa7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeccfa7",
  null
  
)

export default component.exports